import {Typography, ImageWithFallback} from '@purpose/ui/components';
import {cn} from '@purpose/ui/lib/utils';
import {
  CARD_WIDTH,
  WIDGET_CARD_RADIUS,
  WIDGET_TITLE_SIZE,
  WIDGET_TITLE_WEIGHT
} from '@/utils/constants';
import {widgetColors as colors} from '@purpose/ui/utils';

const BenefitCard = ({
  image,
  title,
  titleSize,
  titleWeight,
  radius,
  onClick,
  color = 'dark_blue',
  fallbackWrapperClassName,
  isSingleColumn
}: {
  image: string;
  title: string;
  color?: string;
  titleSize: WIDGET_TITLE_SIZE;
  titleWeight: WIDGET_TITLE_WEIGHT;
  radius: WIDGET_CARD_RADIUS;
  onClick: () => void;
  fallbackWrapperClassName?: string;
  isSingleColumn?: boolean;
}) => {
  const colorFromMap = colors.find(({value}) => value === color);

  const cardRadius = {
    [WIDGET_CARD_RADIUS.none]: undefined,
    [WIDGET_CARD_RADIUS.small]: 4,
    [WIDGET_CARD_RADIUS.medium]: 8,
    [WIDGET_CARD_RADIUS.large]: 16
  };

  return (
    <div
      className="card-container"
      style={{
        width: '100%',
        cursor: 'pointer',
        display: 'flex',
        gap: isSingleColumn ? '12px' : '4px',
        overflow: 'hidden',
        position: 'relative',
        justifyContent: 'space-between',
        maxHeight: '192px',
        flexDirection: isSingleColumn ? 'row' : 'column'
      }}
      onClick={onClick}
    >
      <ImageWithFallback
        className="card-image"
        fallbackWrapperClassName={fallbackWrapperClassName}
        width="100%"
        height="100%"
        containerStyle={{
          minHeight: 151,
          minWidth: CARD_WIDTH,
          maxWidth: CARD_WIDTH,
          borderRadius: cardRadius[radius]
        }}
        src={image}
        alt={title || 'card image'}
        priority
        loading="eager"
        placeholder="empty"
        quality={85}
        sizes="151px"
        fill
        iconStyles={{
          width: 100,
          height: 100
        }}
      />
      <Typography
        className={cn(
          'text-primary-base my-2',
          {'text-[12px]': titleSize === WIDGET_TITLE_SIZE.small},
          {'text-[14px]': titleSize !== WIDGET_TITLE_SIZE.small},
          {'font-normal': titleWeight === WIDGET_TITLE_WEIGHT.regular},
          {'font-medium': titleWeight === WIDGET_TITLE_WEIGHT.medium},
          {'font-semibold': titleWeight === WIDGET_TITLE_WEIGHT.bold},
          {'line-clamp-1': !isSingleColumn},
          {'content-center': isSingleColumn}
        )}
        style={{color: colorFromMap?.color || undefined}}
      >
        {title}
      </Typography>
    </div>
  );
};

export default BenefitCard;
